export class LayoutDataKeys {
    static readonly IsMenuBlockedKey = "IsMenuBlocked";
}